import { Button, PasswordInput, TextInput } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { api } from "../../api/client";
import { errorMessage } from "../../shared/session/errors";
import { saveOnboarding } from "../../shared/session/session";
import { FormError, Page } from "../../shared/ui/Page";

export function ResumeOnboardingPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [idNumber, setIdNumber] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    const { data, error } = await api.POST("/auth/onboarding/resume", { body: { id_number: idNumber, password } });
    if (!data) return setError(errorMessage(error, t("error.generic")));
    saveOnboarding(data.onboarding_token);
    navigate("/onboarding");
  };
  return (
    <Page title={t("onboarding.resume_title")}>
      <form onSubmit={submit}>
        <TextInput
          label={t("signup.id_number")}
          inputMode="numeric"
          value={idNumber}
          onChange={(e) => setIdNumber(e.currentTarget.value)}
          required
          mb="sm"
        />
        <PasswordInput
          label={t("signup.password")}
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.currentTarget.value)}
          required
          mb="md"
        />
        <FormError message={error} />
        <Button type="submit" fullWidth mt="sm">
          {t("form.submit")}
        </Button>
      </form>
    </Page>
  );
}
